import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(
  window.SYSTEM_INFORMATION?.STRIPE_PUBLIC_KEY || 'pk_test_FVaJNIaeawWbf6FC1WuHqPaZ00RRv9liwX'
);
export default stripePromise;
